import React, { useRef, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";

import { useToast } from "../../core/contexts/toast";

import FiltroPI from "./filtro";
import { useAutenticação } from "../../core/contexts/auth";
import { atualizaTamanhoTabela } from "../../core/utils/funcoes";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement, ArcElement } from 'chart.js';
ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, ArcElement);
import SopProductionFollowerProgressCard from "./SopProductionFollowerProgressCard";
import SopProductionGrowthChart from "./SopProductionGrowthChart";
import SopProductionScheduleAdherence from "./SopProductionScheduleAdherence";
import SopProductionRevenueStackedBarChart from "./SopProductionRevenueStackedBarChart";
import { FiltroSopProduction, RepositorioSopProduction } from "../../core/repositories/sopProductionRepositorio";
import SopProductionTable from "./SopProductionTable";
import { ModeloSopProduction } from "../../core/models/sopProduction";

var contador: number = 0;

export default function SopProduction() {
  const { t } = useTranslation();
  const bodyRef = useRef(null);
  const { mostrarToast } = useToast();
  const { usuario } = useAutenticação()
  const [filtro, setFiltro] = useState(new FiltroSopProduction());
  const [lista, setLista] = useState<ModeloSopProduction[]>([])
  const [activeTab, setActiveTab] = useState<'home' | 'table'>('home');

  const [scheduleAdherence, setScheduleAdherence] = useState(0);
  const [capacityUtilization, setCapacityUtilization] = useState(0);



  React.useEffect(() => {
    setTimeout(() => {
      atualizaTamanhoTabela()
      // Seu código a ser executado quando a altura da página mudar para atualizar o tamanho da tabela
      const observer = new MutationObserver(atualizaTamanhoTabela);
      if (bodyRef.current) {
        observer.observe(bodyRef.current, { attributes: true, childList: true, subtree: true });
      }
      return () => {
        observer.disconnect();
      };
    }, 1000);
  }, []);


  React.useEffect(() => {
    if (usuario && usuario.cod_usuario) {
      carregarDados(filtro, true)
    }
  }, [usuario]);

  function diferentes(filtroP: FiltroSopProduction) {
    return filtroP.dth_inicio != filtro.dth_inicio || filtroP.dth_fim != filtro.dth_fim || filtroP.cod_business_unit != filtro.cod_business_unit || filtroP.cod_region != filtro.cod_region || filtroP.cod_product_family != filtro.cod_product_family || filtroP.cod_product != filtro.cod_product || filtroP.value != filtro.value
  }
  async function carregarDados(filtroP: FiltroSopProduction, forca = false) {
    try {
      if (forca || diferentes(filtroP)) {
        const _contador = contador++;
        if (_contador === contador - 1) {
          filtroP.cod_usuario = usuario?.cod_usuario

          const resposta = await new RepositorioSopProduction().getFilter(filtroP)
          console.log(resposta)
          setLista(resposta)
          // await carregarLista(filtro);
          // atualizarInterface();

          const kpis = await new RepositorioSopProduction().postCards(filtroP)
          if (kpis && kpis.length > 0) {
            setScheduleAdherence(kpis[0].schedule_adherence_percentage);
            setCapacityUtilization(kpis[0].capacity_utilization_percentage*100);
          }
        }
      }
    } catch (error) {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    }
  }

  function atualizarFiltro(filtroP: FiltroSopProduction) {
    if (diferentes(filtroP)) {
      carregarDados(filtroP);
      setFiltro({ ...filtroP });
    }
  }

  async function filtrarDados(novoFiltro: FiltroSopProduction) {
    novoFiltro.flg_aberto = false
    atualizarFiltro(novoFiltro)
    // carregarDados(novoFiltro);
  }

  return (
    <div className="SopProduction " ref={bodyRef}>
      <div className="px-2">

        <FiltroPI
          titulo={t("Production")}
          filtro={{...filtro}}
          atualizarFiltro={atualizarFiltro}
          permissaoEditar={true}
          filtrarDados={filtrarDados}
        />
      </div>


      <div className="table-100" >
        <div id="tabela">
          <div className="table-responsive">

            <div className="tabs-container card px-2  shadow-sm border-0">
              <ul className="nav nav-tabs">
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'home' ? 'active' : ''}`}
                    onClick={() => setActiveTab('home')}
                  >
                    Home
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'table' ? 'active' : ''}`}
                    onClick={() => setActiveTab('table')}
                  >
                    Table
                  </button>
                </li>
              </ul>

              <div className="tab-content py-2 ">
                <div className="tab-pane" style={{ display: activeTab === 'home' ? 'block' : 'none' }}  >
                  <Row className="">
                    <Col md={3}>
                      <div style={{ height: '250px' }}>
                        <SopProductionFollowerProgressCard maxLabel="100" title="Schedule Adherence" percent={scheduleAdherence} subtitle="Adherence to the monthly production schedule" />
                      </div>

                    </Col>
                    <Col md={3}>
                      <Card>
                        <div className="blue-line">
                          <SopProductionFollowerProgressCard maxLabel="100" title="Capacity Utilization" percent={capacityUtilization} subtitle="Percentage of available capacity used monthly" />
                        </div>
                      </Card>
                    </Col>

                    <Col md={6}>
                      <Card>
                        <SopProductionGrowthChart filtro={filtro} />
                      </Card>
                    </Col>
                  </Row>

                  <Row className=" mt-3">
                    <Col md={6}>
                      <Card>
                        <SopProductionScheduleAdherence />
                      </Card>
                    </Col>
                    <Col md={6}>
                      <Card>
                        <SopProductionRevenueStackedBarChart filtro={filtro} />
                      </Card>
                    </Col>
                  </Row>
                </div>

                <div className="tab-pane" style={{ display: activeTab !== 'home' ? 'block' : 'none' }}  >

                  {/* <Row className=" mt-3">
                      <Col md={12}>
                        <Card >
                          <SummaryTable />
                        </Card>
                      </Col>
                    </Row> */}

                  <div className="table-100" >
                    <strong className=" title-card pb-1">Production vs Forecast vs Budget Table</strong>
                    <div className="py-2">
                      <SopProductionTable lista={lista} setLista={setLista} />
                    </div>
                  </div>
                </div>
              </div>
            </div>




          </div>

        </div>
      </div>


    </div>
  );
}
